import { Epic, ofType } from 'redux-observable';
import { from, of } from 'rxjs';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';
import { RootAction, RootState, Services } from 'typesafe-actions';
import { getAuthorizedEntities } from '../../actions/lp';
import {
  GET_AUTHORIZED_ENTITIES_FAILURE,
  GET_AUTHORIZED_ENTITIES_REQUEST,
} from '../../actions/lp/actionTypes';
import { addNotification } from '../../actions/ui';
import {
  DEFAULT_NOTIFICATION_CLOSE_TIMEOUT,
  NotificationTypeEnum,
} from '../../actions/ui/types';

export const getAuthorizedEntitiesEpic: Epic<
  RootAction,
  RootAction,
  RootState,
  Services
> = (action$, state$, { api }) =>
  action$.pipe(
    ofType(GET_AUTHORIZED_ENTITIES_REQUEST),
    switchMap((action) => {
      const { entityFilter, logisticsPartyId } = action.payload;
      return from(
        api.clwsServices
          .getAuthorizedEntitiesService({ entityFilter, logisticsPartyId })
          .pipe(
            mergeMap(({ permissionToEntitiesMap }) =>
              of(getAuthorizedEntities.success({ permissionToEntitiesMap }))
            ),
            catchError((err) =>
              of(
                getAuthorizedEntities.failure(err),
                addNotification({
                  type: NotificationTypeEnum.ERROR,
                  action: GET_AUTHORIZED_ENTITIES_FAILURE,
                  message: 'lps.get_authorized_entities.failure',
                  timeout: DEFAULT_NOTIFICATION_CLOSE_TIMEOUT,
                })
              )
            )
          )
      );
    })
  );
export default getAuthorizedEntitiesEpic;
